module.exports = __webpack_public_path__ + "static/media/EchoSabre.40f9a5b9.png";